document.addEventListener('DOMContentLoaded', function () {
  const vehicleInput = document.getElementById('acInput');
  const vehicleBtn = document.getElementById('acGo');
  const vehicleError = document.getElementById('acError');

  /* -----------------------
    VEHICLE VALIDATION
 ----------------------- */
  function normaliseVehicle(value) {
    return value.trim().toUpperCase().replace(/\s+/g, '');
  }

  function validateVehicle(value) {
    const cleaned = normaliseVehicle(value);

    // Plausible UK VRM input only.
    // DVLA/API decides whether the registration actually exists.
    return /^[A-Z0-9]{2,8}$/.test(cleaned);
  }

  vehicleBtn.addEventListener('click', function () {
    const value = vehicleInput.value;

    if (!validateVehicle(value)) {
      vehicleError.hidden = false;
      return;
    }

    vehicleError.hidden = true;

    const cleaned = normaliseVehicle(value);

    window.location.href = `/products/full-vehicle-history-report?reg=${encodeURIComponent(cleaned)}`;
  });

  vehicleInput.addEventListener('input', function () {
    vehicleError.hidden = true;
  });

  vehicleInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      vehicleBtn.click();
    }
  });

});